import { useInfiniteQuery } from '@tanstack/react-query';

import {
  formatInfiniteData,
  getNextPageParam,
} from 'components/helpers/reactQuery';

export function useInfiniteDivisionSearchesQuery({
  params = {},
  queryOptions,
}) {
  return useInfiniteQuery({
    queryKey: ['divisionSearches', params],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.post('/division_searches', {
        division_search: { ...params, page: pageParam },
      });

      return response.data;
    },
    getNextPageParam,
    select: (data) => formatInfiniteData({ data }),
    ...queryOptions,
  });
}
